import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'referalSearchfilter'
})
export class ReferalSearchPipe implements PipeTransform {

  transform(items: any[], filter: string): any {

    if (!items || !filter) {
      return items;
    }
    items = items.filter(item => item.firstName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.lastName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.clinicName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.studentGradevalue.toLowerCase().indexOf(filter.toLowerCase()) !== -1 );
    return items;
  }
}
